// extracted by mini-css-extract-plugin
module.exports = {"base":"header-module--base--v_mGn","menu":"header-module--menu--1ZrJH"};